// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2f44e64d","113":"25805206","118":"bd2d8d7f","201":"8a69a2eb","242":"4b33dc63","309":"1c91cf48","423":"179ba460","453":"222056e3","502":"91b030c2","682":"5f017ae3","701":"9259f06d","977":"dff16f68"}[chunkId] + ".chunk.js";
};